import { Subscription } from 'embedded/api/out/Subscription';
import { Identity } from 'embedded/api/out/Identity';
import { v4 as uuid } from 'uuid';
import { keyedWindow } from 'utils/globalWindowVariables';
import { OutTopic } from 'embedded/api/out/OutTopic';
import { LoggingService } from '@instinet-analytics/core-lib';
import { buildLogger, Logger } from '@instinet-analytics/core-lib';

interface WindowWithCefQuery {
    cefQuery: (message: unknown) => void;
}

export const windowWithCefQuery = () =>
    keyedWindow['cefQuery'] ? (keyedWindow as WindowWithCefQuery) : undefined;

export class WindowsCefQuerySubscriber implements Subscription<unknown> {
    private logger: Logger;

    public constructor(
        private topic: OutTopic,
        loggingService: LoggingService
    ) {
        this.logger = buildLogger('WindowsCefQuerySubscriber', loggingService);
        this.logger.debug('Added WindowsCefQuerySubscriber for topic ' + topic);
    }

    public identity: Identity = {
        uuid: uuid(),
        name: 'WindowsCefQuerySubscriber',
    };

    public listener(message: unknown): void {
        const msg = {
            request: JSON.stringify({
                event: this.topic, // Temporary: will be removed in https://jira.isn.instinet.com:8443/browse/IND2-2156
                topic: this.topic,
                message,
            }),
        };
        if (windowWithCefQuery()) {
            try {
                windowWithCefQuery()!.cefQuery(msg);
            } catch (error) {
                const err = error as Error;
                this.logger.warn('Error calling window.cefQuery', {
                    message: msg,
                    error: err.toString(),
                    errorMessage: err.message,
                });
                throw err;
            }
        }
    }
}

export class WindowsCefQuerySubscriberFactory {
    private subscribers: Partial<Record<OutTopic, WindowsCefQuerySubscriber>> =
        {};

    public getSubscriber(
        topic: OutTopic,
        loggingService: LoggingService
    ): WindowsCefQuerySubscriber | undefined {
        if (!windowWithCefQuery()) {
            return undefined;
        }
        if (!this.subscribers[topic]) {
            this.subscribers[topic] = new WindowsCefQuerySubscriber(
                topic,
                loggingService
            );
        }
        return this.subscribers[topic];
    }
}
